import { Col, Modal, Row } from "react-bootstrap";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import { GroupButton } from "../../components/GroupButton";
import TableCustom, { columnNamesType } from "../../components/table-custom/TableCustom";
import { FORMAT_DATE, INIT_SEARCH_OBJECT, RESPONSE_STATUS_CODE, TYPE } from "../../constants/moduleConsts";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import AppContext from "../../../AppContext";
import { searchListEmployeeSynthetic } from "../../timesheet/services/timesheetServices";
import { toast } from "react-toastify";
import InputSearch from "../../components/input/InputSearch";
import { TYPE_TIMEKEEPING_SYNTHETIC } from "../constants/timekeepingOverviewConsts";

interface IProps {
    open: boolean;
    handleClose: () => void;
    data: any;
}

const TimekeepingSyntheticDialog = (props: IProps) => {
    const {
        open,
        handleClose,
        data
    } = props;

    const { lang } = useMultiLanguage();
    const { setPageLoading } = useContext(AppContext);

    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [searchObject, setSearchObject] = useState<any>({
        ...INIT_SEARCH_OBJECT,
        employeeText: null,
        type: data.type,
        phongBanId: data.phongBanId,
        fromDate: data.fromDate ? moment(data.fromDate).format(FORMAT_DATE.YYYY_MM_DD_INPUT) : '',
        toDate: data.toDate ? moment(data.toDate).format(FORMAT_DATE.YYYY_MM_DD_INPUT) : '',
    });
    const [employeeList, setEmployeeList] = useState([]);
    const [initPageable, setInitPageable] = useState<any>({
        totalElements: 0,
        totalPages:0,
        numberOfElements: 0,
    });

    useEffect(() => {
        if(searchObject?.pageIndex && searchObject?.pageSize) {
            handleSearch(searchObject);
        }
    }, [searchObject?.pageIndex, searchObject?.pageSize])

    const handleSearch = async (searchObject: any) => {
        try {
            setPageLoading(true);
            const { data } = await searchListEmployeeSynthetic(searchObject);
            if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
                setEmployeeList(data?.data?.content || [])
                setInitPageable(data?.data?.pageable || {
                    totalElements: 0,
                    totalPages: 0,
                    numberOfElements: 0,
                })
            } else toast.warning(data?.message);
            open && setIsOpen(open)
        } catch (error) {
            toast.error(lang("GENERAL.ERROR"));
        } finally {
            setPageLoading(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchObject({
          ...searchObject,
          employeeText: e.target?.value
        });
    };

    const  convertType = (type: TYPE_TIMEKEEPING_SYNTHETIC): string => {
        switch (type) {
          case TYPE_TIMEKEEPING_SYNTHETIC.DI_LAM:
            return "Đi làm";
          case TYPE_TIMEKEEPING_SYNTHETIC.NGHI:
            return "Nghỉ";
          case TYPE_TIMEKEEPING_SYNTHETIC.DI_HOC:
            return "Đi học";
          case TYPE_TIMEKEEPING_SYNTHETIC.TRUC:
            return "Trực";
          case TYPE_TIMEKEEPING_SYNTHETIC.NGHI_BU:
            return "Nghỉ bù";
          case TYPE_TIMEKEEPING_SYNTHETIC.OM:
            return "Ốm";
          case TYPE_TIMEKEEPING_SYNTHETIC.PHEP:
            return "Phép";
          default:
            return "";
        }
      }

    const columns: columnNamesType[] = [
        {
            name: "STT",
            field: "stt",
            render: (row: any, index: number, numericalOrder: number) => <span>{numericalOrder}</span>,
        },
        {
            name: lang("INPUT.FULLNAME"),
            field: "employeeText",
            headerStyle: {
                minWidth: 300
            },
            cellStyle: {
                textAlign: "left"
            },
        },
        {
            name: lang("PROFILE.ROLE"),
            field: "chucVuText",
            headerStyle: {
                minWidth: 200
            }
        },
        {
            name: lang("IMPLEMENTATION.DATE"),
            field: "ngayThucHien",
            headerStyle: {
                minWidth: 100
            },
            render: (row: any, index: number) => <span>{row.ngayThucHien ? moment(row.ngayThucHien).format("DD/MM/YYYY") : ''}</span>,
        },
    ];

    return (
        <Modal
            show={isOpen}
            onHide={() => {
                handleClose();
                setIsOpen(false);
            }}
            backdrop="static"
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {`${lang("ISSUE.LIST_EMPLOYEES")} ${convertType(data.type).toLowerCase()} - ${data.phongBanText || ''}`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="g-4 relative spaces z-index-4">
                    <Col xs={5} xl={6} xxl={7}></Col>
                    <Col xs={7} xl={6} xxl={5} className="flex">
                        <div className="spaces mr-10 flex-1">
                            <InputSearch
                                className="border-3px"
                                value={searchObject?.employeeText}
                                placeholder="Tìm kiếm theo tên nhân viên"
                                handleSearch={() => handleSearch(searchObject)}
                                handleChange={handleChange}
                                isEnter
                            />
                        </div>
                    </Col>
                    <Col sm={12} md={12} lg={12}>
                        <Row>
                            <TableCustom
                                height={420}
                                id="shift-list"
                                data={employeeList}
                                columns={columns}
                                searchObject={searchObject}
                                setSearchObject={setSearchObject}
                                notDelete={true}
                                justFilter={true}
                                clearToolbar={true}
                                totalPages={initPageable.totalPages}
                                totalElements={initPageable.totalElements}
                                numberOfElements={initPageable.numberOfElements}
                            />
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <GroupButton
                    type="btn-cancel"
                    handleCloseUpdateDialog={() => {
                        handleClose();
                        setIsOpen(false);
                    }}
                />
            </Modal.Footer>
        </Modal>
    )
};

export default TimekeepingSyntheticDialog;